import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AdminFeeSettings,
  BalanceCard,
  ProfileSettings,
  PasswordChange,
  UsageStatistics,
} from '@/components/account';
import { StripePaymentForm } from '@/components/billing/StripePaymentForm';

export default function AccountPage() {
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Account Management</h1>
        <Link
          to="/billing"
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-sm font-medium"
        >
          View Billing Details
        </Link>
      </div>

      {/* Payment Form Modal */}
      {showPaymentForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="max-w-lg w-full">
            <StripePaymentForm
              onSuccess={() => setShowPaymentForm(false)}
              onCancel={() => setShowPaymentForm(false)}
            />
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Content - Profile and Password */}
        <div className="lg:col-span-2 space-y-6">
          <ProfileSettings />
          <PasswordChange />
          <AdminFeeSettings />
        </div>

        {/* Sidebar - Balance and Usage */}
        <div className="space-y-6">
          <BalanceCard
            onAddFunds={() => setShowPaymentForm(true)}
            showAddButton={true}
          />
          <UsageStatistics />
        </div>
      </div>

      {/* Additional Info Section */}
      <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-blue-900 mb-3">Need Help?</h2>
        <p className="text-sm text-blue-800 mb-4">
          If you have any questions about your account, billing, or need assistance, please
          contact our support team.
        </p>
        <div className="flex gap-4">
          <Link
            to="/billing"
            className="text-sm text-blue-700 hover:text-blue-800 font-medium underline"
          >
            View Transaction History
          </Link>
          <a
            href="mailto:support@permit-extractor.com"
            className="text-sm text-blue-700 hover:text-blue-800 font-medium underline"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}
